import * as tslib_1 from "tslib";
import React from 'react';
import classNames from 'classnames';
import isEmpty from 'lodash.isempty';
import { ToolbarButton } from 'wix-rich-content-common';
import stylez from 'wix-rich-content-common/dist/statics/styles/inline-toolbar-button.scss';
import LinkIcon from '../../../../assets/da-editor/plugins/image/link-icon.inline.svg';
import InlineSvg from '../../../components/InlineSvg';
import { BiDataHook } from '../../../../biLogger';
var InlineToolbarButton = /** @class */ (function (_super) {
    tslib_1.__extends(InlineToolbarButton, _super);
    function InlineToolbarButton(props) {
        var _a, _b, _c, _d;
        var _this = _super.call(this, props) || this;
        _this.handleClick = function (e) {
            e.preventDefault();
            _this.props.onClick && _this.props.onClick();
        };
        _this.preventBubblingUp = function (event) { return event.preventDefault(); };
        _this.renderButton = function () {
            var _a;
            var _b = _this.props, isActive = _b.isActive, tooltipText = _b.tooltipText, tabIndex = _b.tabIndex;
            var styles = _this.styles;
            var iconClassNames = classNames(styles.icon, (_a = {},
                _a[styles.active] = isActive,
                _a));
            return (React.createElement("div", { className: styles.buttonWrapper, onMouseDown: _this.preventBubblingUp },
                React.createElement("button", { tabIndex: tabIndex, "aria-label": tooltipText, "aria-pressed": isActive, "data-hook": BiDataHook.CODEBLOCK_BUTTON, onClick: _this.handleClick, className: styles.button },
                    React.createElement("div", { className: iconClassNames },
                        React.createElement(InlineSvg, { icon: LinkIcon })))));
        };
        var _e = (props.theme || {}).buttonStyles, buttonStyles = _e === void 0 ? {} : _e;
        _this.styles = {
            button: classNames(stylez.inlineToolbarButton, (_a = {},
                _a[buttonStyles.inlineToolbarButton] = !!buttonStyles.inlineToolbarButton,
                _a[buttonStyles.pluginToolbarButton] = !!buttonStyles.pluginToolbarButton,
                _a)),
            buttonWrapper: classNames(stylez.inlineToolbarButton_wrapper, (_b = {},
                _b[buttonStyles.inlineToolbarButton_wrapper] = !!buttonStyles.inlineToolbarButton_wrapper,
                _b[buttonStyles.pluginToolbarButton_wrapper] = !!buttonStyles.pluginToolbarButton_wrapper,
                _b)),
            icon: classNames(stylez.inlineToolbarButton_icon, (_c = {},
                _c[buttonStyles.inlineToolbarButton_icon] = !!buttonStyles.inlineToolbarButton_icon,
                _c[buttonStyles.pluginToolbarButton_icon] = !!buttonStyles.pluginToolbarButton_icon,
                _c)),
            active: classNames(stylez.inlineToolbarButton_active, (_d = {},
                _d[buttonStyles.inlineToolbarButton_active] = !!buttonStyles.inlineToolbarButton_active,
                _d[buttonStyles.pluginToolbarButton_active] = !!buttonStyles.pluginToolbarButton_active,
                _d)),
        };
        return _this;
    }
    InlineToolbarButton.prototype.render = function () {
        var _a = this.props, theme = _a.theme, isMobile = _a.isMobile, tooltipText = _a.tooltipText;
        var showTooltip = !isMobile && !isEmpty(tooltipText);
        return (React.createElement(ToolbarButton, { theme: theme, showTooltip: showTooltip, tooltipText: tooltipText, button: this.renderButton(), tooltipOffset: { y: -20 } }));
    };
    return InlineToolbarButton;
}(React.Component));
export default InlineToolbarButton;
//# sourceMappingURL=inlineButton.js.map